import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/28.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Po co ci łódka?"
            question=""
            audio={audio}
            answers={{
                ans1: "Do widzenia!",
            }}
            links={{
                link1: PAGES.p57,
            }}
            content={
                <div>
                <ul>
                    <li>Łódka? My na to mówimy koryto. Przydaje się, bo woda z Warty często wylewa. A ja swoje gęsi trzymam na wyspie, to i jeszcze częściej się przydaje…</li>
                    <li>Na wyspie? – dopytujesz. – Dlaczego?</li>
                    <li>Mało tu lisów albo dzikich psów? Moje gęsi są tam bezpieczne. Ale jak inni mi tego zazdroszczą, nie rozumieją… Mówią, że kto wie więcej dzień przed wszystkimi, przez dzień jest głupcem. Ale nie złoszczę się na nich, tacy są ludzie…</li>
                </ul>
            </div>
            }
        />

    );
}